import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BusinessEntityTempDTO  {
    _originalTypeClassName = "zERP.BO.BusinessEntityTempDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BusinessEntityTempDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.ShortName = null;
this.Description = null;
this.BranchNumber = null;
this.PublicSector = false;
this.TaxNumber = null;
this.StartDate = null;
this.Status = null;
this.Kind = null;
this.TerminationDate = null;
this.TerminationReason = null;
this.BookType = null;
this.AdministrationStartPeriod = null;
this.AdministrationEndPeriod = null;
this.HasTax = false;
this.AME = null;
this.AADEUser = null;
this.AADEKey = null;
this.ErganiUser = null;
this.ErganiPassword = null;
this.EFKA_Code = null;
this.EFKA_Branch = null;
this.EFKA_LegalEntityName = null;
this.EFKA_IndividualName = null;
this.EFKA_IndividualFatherName = null;
this.IntraCommunityTransactions = false;
this.InheritBankAccount = false;
this.InheritsOccupationalPhysicians = false;
this.InheritsSecurityTechnicians = false;
this.InheritsRepresentationDetails = false;
this.InheritsEmploymentLabourDetails = false;
this.InheritsMainInsuranceFund = false;
this.InheritsSubsidiaryInsuranceFund = false;
this.SEPE_Code = null;
this.OAED_Code = null;
this.CostCenterFrom = null;
this.CostCenterTo = null;
this.CurrencyDecimalAccuracy = null;
this.Code = null;
this.ErgodotikiOrganosi = null;
this.ContactDetails = null;
this.DefaultCurrency = null;
this.Departments = null;
this.TaxOffice = null;
this.Type = null;
this.Brances = null;
this.BranchOwner = null;
this.SubCompanies = null;
this.ParentCompany = null;
this.Country = null;
this.TaxOfficeSICs = null;
this.BankAccounts = null;
this.Addresses = null;
this.CashAccounts = null;
this.Holidays = null;
this.RepresentationDetail = null;
this.EmploymentAndLabourDetail = null;
this.MainInsuranceFund = null;
this.SubsidiaryInsuranceFund = null;
this.OccupationalPhysicians = null;
this.SecurityTechnicians = null;
this.PayrollBankAccount = null;
this.DefaultBankAccount = null;
this.Location = null;
this.CostCenter = null;
this.TaxAddress = null;
this.SEPE_Branch = null;
this.BusinessEntityErganiSIC = null;
this.SEPE_DimotikiEnothta = null;
this.DYPA_Branch = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
ShortName:any;
Description:any;
BranchNumber:any;
PublicSector:any;
TaxNumber:any;
StartDate:any;
Status:any;
Kind:any;
TerminationDate:any;
TerminationReason:any;
BookType:any;
AdministrationStartPeriod:any;
AdministrationEndPeriod:any;
HasTax:any;
AME:any;
AADEUser:any;
AADEKey:any;
ErganiUser:any;
ErganiPassword:any;
EFKA_Code:any;
EFKA_Branch:any;
EFKA_LegalEntityName:any;
EFKA_IndividualName:any;
EFKA_IndividualFatherName:any;
IntraCommunityTransactions:any;
InheritBankAccount:any;
InheritsOccupationalPhysicians:any;
InheritsSecurityTechnicians:any;
InheritsRepresentationDetails:any;
InheritsEmploymentLabourDetails:any;
InheritsMainInsuranceFund:any;
InheritsSubsidiaryInsuranceFund:any;
SEPE_Code:any;
OAED_Code:any;
CostCenterFrom:any;
CostCenterTo:any;
CurrencyDecimalAccuracy:any;
Code:any;
ErgodotikiOrganosi:any;
ContactDetails:any;
DefaultCurrency:any;
Departments:any;
TaxOffice:any;
Type:any;
Brances:any;
BranchOwner:any;
SubCompanies:any;
ParentCompany:any;
Country:any;
TaxOfficeSICs:any;
BankAccounts:any;
Addresses:any;
CashAccounts:any;
Holidays:any;
RepresentationDetail:any;
EmploymentAndLabourDetail:any;
MainInsuranceFund:any;
SubsidiaryInsuranceFund:any;
OccupationalPhysicians:any;
SecurityTechnicians:any;
PayrollBankAccount:any;
DefaultBankAccount:any;
Location:any;
CostCenter:any;
TaxAddress:any;
SEPE_Branch:any;
BusinessEntityErganiSIC:any;
SEPE_DimotikiEnothta:any;
DYPA_Branch:any;

static assignPreviousBusiness($this: any, business: any): any{let temp = [];
$this.Name = business?.Name;
$this.ShortName = business?.ShortName;
$this.Description = business?.Description;
$this.BranchNumber = business?.BranchNumber;
$this.PublicSector = business?.PublicSector;
$this.TaxNumber = business?.TaxNumber;
$this.Status = business?.Status;
$this.Kind = business?.Kind;
$this.TerminationReason = business?.TerminationReason;
$this.BookType = business?.BookType;
$this.HasTax = business?.HasTax;
$this.AME = business?.AME;
$this.AADEUser = business?.AADEUser;
$this.AADEKey = business?.AADEKey;
$this.ErganiUser = business?.ErganiUser;
$this.ErganiPassword = business?.ErganiPassword;
$this.EFKA_Code = business?.EFKA_Code;
$this.EFKA_Branch = business?.EFKA_Branch;
$this.EFKA_LegalEntityName = business?.EFKA_LegalEntityName;
$this.EFKA_IndividualName = business?.EFKA_IndividualName;
$this.EFKA_IndividualFatherName = business?.EFKA_IndividualFatherName;
$this.IntraCommunityTransactions = business?.IntraCommunityTransactions;
$this.SEPE_Code = business?.SEPE_Code;
$this.OAED_Code = business?.OAED_Code;
$this.Code = business?.Code;
$this.ErgodotikiOrganosi = business?.ErgodotikiOrganosi;
$this.CurrencyDecimalAccuracy = business?.CurrencyDecimalAccuracy;
if ((Domain.DateHelper.IsDateNull(business?.StartDate))) {$this.StartDate = null;}else {$this.StartDate = business?.StartDate;}
if ((Domain.DateHelper.IsDateNull(business?.TerminationDate))) {$this.TerminationDate = null;}else {$this.TerminationDate = business?.TerminationDate;}
if ((Domain.DateHelper.IsDateNull(business?.AdministrationStartPeriod))) {$this.AdministrationStartPeriod = null;}else {$this.AdministrationStartPeriod = business?.AdministrationStartPeriod;}
if ((Domain.DateHelper.IsDateNull(business?.AdministrationEndPeriod))) {$this.AdministrationEndPeriod = null;}else {$this.AdministrationEndPeriod = business?.AdministrationEndPeriod;}
if ((Domain.DateHelper.IsDateNull(business?.CostCenterFrom))) {$this.CostCenterFrom = null;}else {$this.CostCenterFrom = business?.CostCenterFrom;}
if ((Domain.DateHelper.IsDateNull(business?.CostCenterTo))) {$this.CostCenterTo = null;}else {$this.CostCenterTo = business?.CostCenterTo;}
if ((business?.ParentCompany != null)) {$this.ParentCompany = business?.ParentCompany?.Id;}
if ((business?.Country != null)) {$this.Country = business?.Country?.Id;}
if ((business?.TaxAddress != null)) {$this.TaxAddress = business?.TaxAddress?.Id;}
if ((business?.TaxOffice != null)) {$this.TaxOffice = business?.TaxOffice?.Id;}
if ((business?.Type != null)) {$this.Type = business?.Type?.Id;}
if ((business?.PayrollBankAccount != null)) {$this.PayrollBankAccount = business?.PayrollBankAccount?.Id;}
if ((business?.DefaultBankAccount != null)) {$this.DefaultBankAccount = business?.DefaultBankAccount?.Id;}
if ((business?.DefaultCurrency != null)) {$this.DefaultCurrency = business?.DefaultCurrency?.Id;}
if ((business?.RepresentationDetail != null)) {$this.RepresentationDetail = business?.RepresentationDetail?.Id;}
if ((business?.ContactDetails != null)) {$this.ContactDetails = business?.ContactDetails?.Id;}
if ((business?.Departments != null)) {for (let _iitem = 0; _iitem < (business?.Departments == null ? 0 : business?.Departments.length); _iitem++) {let item = business?.Departments[_iitem];temp?.add(item?.Id?.toString());}$this.Departments = CLMS.Framework.String.Join(", ", temp);temp?.splice(0, temp.length);}
if ((business?.BankAccounts != null)) {for (let _iitem = 0; _iitem < (business?.BankAccounts == null ? 0 : business?.BankAccounts.length); _iitem++) {let item = business?.BankAccounts[_iitem];temp?.add(item?.Id?.toString());}$this.BankAccounts = CLMS.Framework.String.Join(", ", temp);temp?.splice(0, temp.length);}
if ((business?.Addresses != null)) {for (let _iitem = 0; _iitem < (business?.Addresses == null ? 0 : business?.Addresses.length); _iitem++) {let item = business?.Addresses[_iitem];temp?.add(item?.Id?.toString());}$this.Addresses = CLMS.Framework.String.Join(", ", temp);temp?.splice(0, temp.length);}
if ((business?.Holidays != null)) {for (let _iitem = 0; _iitem < (business?.Holidays == null ? 0 : business?.Holidays.length); _iitem++) {let item = business?.Holidays[_iitem];temp?.add(item?.Id?.toString());}$this.Holidays = CLMS.Framework.String.Join(", ", temp);temp?.splice(0, temp.length);}
if ((business?.TaxOfficeSICs != null)) {for (let _iitem = 0; _iitem < (business?.TaxOfficeSICs == null ? 0 : business?.TaxOfficeSICs.length); _iitem++) {let item = business?.TaxOfficeSICs[_iitem];temp?.add(item?.Id?.toString());}$this.TaxOfficeSICs = CLMS.Framework.String.Join(", ", temp);temp?.splice(0, temp.length);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}